export const EVENT_MASK_ACCEPT = 'maskaccept';

export const EVENT_MASK_COMPLETE = 'maskcomplete';
